var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModuleContainer',_vm._b({scopedSlots:_vm._u([{key:"btn",fn:function(){return [_c('MapControlButton',{attrs:{"icon":"mdi-home"},on:{"click":_vm.onGoHome}})]},proxy:true}])},'ModuleContainer',_vm.bindModule,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }